
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { AppModule } from '@/store/modules/app'
import { clipboardSuccess } from '@/utils/clipboard'
import {
  getAntManageInfo,
  patchAntManageInfo,
  getAntManageList
} from '@/api/antManage/antManage'
import { queryAddress } from '@/api/product/product'
import { getCurrentDate, dateToSeconds, pickerOptions } from '@/utils/dateTime'
import { delObjEmptyKey } from '@/utils'

const initDate = getCurrentDate()
@Component({
  name: 'basicInformation',
  components: {}
})
export default class extends Vue {
  @Prop() merchant!: any
  @Prop({ required: true }) private merchantId!: any
  get language() {
    return AppModule.language
  }
  private clipboardSuccess = clipboardSuccess
  private pickerOptions: any = pickerOptions

  private form: any = {
    start_time: initDate[0],
    end_time: initDate[1]
  }

  // 创建时间监听
  @Watch('date', { deep: true, immediate: true })
  protected pickerChange() {
    if (this.date) {
      this.form.start_time = dateToSeconds(this.date[0])
      this.form.end_time = dateToSeconds(this.date[1])
    } else {
      this.date = getCurrentDate()
    }
  }

  private date: any[] = getCurrentDate()

  private closeBuy: any = 'None'

  private infoForm: any = {
    username: '',
    password: '',
    ant_type: '',
    status: 1,
    invitation_code: '',
    extra_param: {
      buy_usdt_rebate_rate: '',
      sale_usdt_rebate_rate: '',
      yiji_rebate_rate: '',
      erji_rebate_rate: '',
      sanji_rebate_rate: '',
      close_buy: 'None',
      remark: '',
      is_low_rating: '0'
    },
    phone: ''
    // ancestor: ''
  }
  private isShow: boolean = true
  private isFocus: boolean = false
  private onFocus(val) {
    if (val) {
      this.isFocus = true
    } else {
      this.isFocus = false
    }
  }
  // private inFocus () {
  //   this.isFocus = false
  // }
  private onloadLoading = false
  private rules: any = {
    username: [
      { required: true, message: 'Please enter account ID', trigger: 'blur' }
    ],
    password: [
      { required: true, message: 'Please enter password', trigger: 'blur' }
    ],
    ant_type: [
      { required: true, message: 'Please enter ant_type', trigger: 'blur' }
    ],
    status: [
      { required: true, message: 'Please enter status', trigger: 'blur' }
    ]
  }
  private loading: boolean = false
  private manageList: any = {}
  private async onloadAntManageInfo() {
    try {
      this.loading = true
      const data: any = {
        id: this.merchantId,
        ...this.form
      }
      delObjEmptyKey(data)
      await getAntManageInfo(data).then((res: any) => {
        this.infoForm = res
        if (!res.extra_param) {
          this.infoForm.extra_param = {
            buy_usdt_rebate_rate: '',
            sale_usdt_rebate_rate: '',
            yiji_rebate_rate: '',
            erji_rebate_rate: '',
            sanji_rebate_rate: '',
            close_buy: 'None',
            remark: '',
            is_low_rating: '0'
          }
        } else {
          if (this.infoForm.extra_param.close_buy === 1) {
            this.closeBuy = 1
          } else if (this.infoForm.extra_param.close_buy === 0) {
            this.closeBuy = 0
          } else {
            this.closeBuy = 'None'
          }
          this.infoForm.extra_param = res.extra_param
        }
        this.loading = false
      })
    } catch (e) {
      this.loading = false
    }
  }

  private reset() {
    this.form = {
      start_time: null,
      end_time: null
    }
    this.date = getCurrentDate()
    this.$nextTick(() => {
      this.onloadAntManageInfo()
    })
  }

  private select() {
    this.onloadAntManageInfo()
  }

  private hashJump(address, type) {
    if (type === 'trc20') {
      window.open(`https://tronscan.io/#/address/${address}`)
    } else if (type === 'erc20') {
      window.open(`https://etherscan.io/address/${address}`)
    }
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }
  // 钱包地址 查询
  private async query(row: any) {
    try {
      this.loading = true
      let data: any = {
        address: row
      }
      await queryAddress(data).then(() => {
        if (this.language === 'en') {
          this.$message({
            message: 'Query successfully!',
            type: 'success'
          })
        } else if (this.language === 'zh_cn') {
          this.$message({
            message: '查询成功!',
            type: 'success'
          })
        } else if (this.language === 'zh_tw') {
          this.$message({
            message: '查詢成功!',
            type: 'success'
          })
        }
        this.loading = false
        this.flagStr()
      })
    } catch (e) {
      this.loading = false
    }
  }

  private back() {
    this.$emit('close', false)
  }
  private update() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.onloadLoading = true
          if (this.closeBuy === 'None') {
            this.infoForm.extra_param.close_buy = null
          } else {
            this.infoForm.extra_param.close_buy = this.closeBuy
          }
          await patchAntManageInfo({ ...this.infoForm }).then(() => {
            this.$message({
              message: 'Operation successful!',
              type: 'success'
            })
            this.onloadLoading = false
            // this.back()
          })
        } catch (e) {
          // this.back()
          this.onloadLoading = false
        }
      } else {
        return false
      }
    })
  }

  private masterList: any[] = []
  private listLoading = false
  // 对所有数据进行分页处理 发送请求
  private async getMasterList(name) {
    try {
      this.listLoading = true
      const data: any = {
        name: name,
        page_size: 100,
        page: 1
      }
      await getAntManageList(data).then((res: any) => {
        this.masterList = res.results
        setTimeout(() => {
          this.listLoading = false
        }, 0.5 * 1000)
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 更新输入输入不显示
  private inputText(val) {
    this.$forceUpdate()
  }

  mounted() {
    this.$nextTick(() => {
      this.onloadAntManageInfo()
    })
  }
}
